/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LossOfProductionMetricVariantRepresentation } from './LossOfProductionMetricVariantRepresentation';
import {
    LossOfProductionMetricVariantRepresentationFromJSON,
    LossOfProductionMetricVariantRepresentationFromJSONTyped,
    LossOfProductionMetricVariantRepresentationToJSON,
    LossOfProductionMetricVariantRepresentationToJSONTyped,
} from './LossOfProductionMetricVariantRepresentation';

/**
 * 
 * @export
 * @interface LossOfProductionMetricRepresentation
 */
export interface LossOfProductionMetricRepresentation {
    /**
     * Unique uuid key of this loss-of-production category
     * @type {string}
     * @memberof LossOfProductionMetricRepresentation
     */
    key: string;
    /**
     * Unique uuid key mapping to an i18n entry
     * @type {string}
     * @memberof LossOfProductionMetricRepresentation
     */
    name: string;
    /**
     * variants of this loss of rev category, has at least one entry for the global default variant
     * @type {Array<LossOfProductionMetricVariantRepresentation>}
     * @memberof LossOfProductionMetricRepresentation
     */
    variants: Array<LossOfProductionMetricVariantRepresentation>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LossOfProductionMetricRepresentation
     */
    licenseFeatures: Array<string>;
}

/**
 * Check if a given object implements the LossOfProductionMetricRepresentation interface.
 */
export function instanceOfLossOfProductionMetricRepresentation(value: object): value is LossOfProductionMetricRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('variants' in value) || value['variants'] === undefined) return false;
    if (!('licenseFeatures' in value) || value['licenseFeatures'] === undefined) return false;
    return true;
}

export function LossOfProductionMetricRepresentationFromJSON(json: any): LossOfProductionMetricRepresentation {
    return LossOfProductionMetricRepresentationFromJSONTyped(json, false);
}

export function LossOfProductionMetricRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): LossOfProductionMetricRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'variants': ((json['variants'] as Array<any>).map(LossOfProductionMetricVariantRepresentationFromJSON)),
        'licenseFeatures': json['licenseFeatures'],
    };
}

export function LossOfProductionMetricRepresentationToJSON(json: any): LossOfProductionMetricRepresentation {
    return LossOfProductionMetricRepresentationToJSONTyped(json, false);
}

export function LossOfProductionMetricRepresentationToJSONTyped(value?: LossOfProductionMetricRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'variants': ((value['variants'] as Array<any>).map(LossOfProductionMetricVariantRepresentationToJSON)),
        'licenseFeatures': value['licenseFeatures'],
    };
}

